import { createFileRoute, redirect } from '@tanstack/react-router';
import { ScanPage } from '@pages/scan';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const selectedEventId = sessionStorage.getItem('selectedEventId');
    if (!selectedEventId) {
      throw redirect({ to: '/select-event' });
    }
  },
  component: ScanPage,
});
